import styled from "styled-components";
import themes from '@/styles/themes'

const SubscriptionDetailsBody = styled.div`
  border: 1px solid ${themes.estadao};
  border-radius: 4px;
  padding: 10px 20px;
`

export default SubscriptionDetailsBody